module.exports = __webpack_public_path__ + "static/estate-b6fa203a5b66e7482b1cc9b92e2bd2d6.jpg";